module.exports = __webpack_public_path__ + "8538e89bc0b7739cf6b614ed0bba48cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/desktop-tablet-phone.jpeg
// module id = 695
// module chunks = 0